/**
 * Unterstützte Oberflächensprachen.
 *
 * `nativeName` wird NIE übersetzt — die Sprachauswahl zeigt jede Sprache in
 * ihrer eigenen Schreibweise, damit ein Benutzer auch dann wieder herausfindet,
 * wenn er versehentlich eine fremde Sprache gewählt hat.
 *
 * `bcp47` steuert Datums-/Zahlenformate (Intl), `code` ist der i18next-Schlüssel.
 */
export interface SupportedLanguage {
  code: string;
  bcp47: string;
  nativeName: string;
  /** Englischer Name — nur für Suche/Filter in der Sprachauswahl. */
  englishName: string;
}

export const SUPPORTED_LANGUAGES: readonly SupportedLanguage[] = [
  { code: 'de', bcp47: 'de-DE', nativeName: 'Deutsch',    englishName: 'German' },
  { code: 'en', bcp47: 'en-GB', nativeName: 'English',    englishName: 'English' },
  { code: 'tr', bcp47: 'tr-TR', nativeName: 'Türkçe',     englishName: 'Turkish' },
  { code: 'fr', bcp47: 'fr-FR', nativeName: 'Français',   englishName: 'French' },
  { code: 'es', bcp47: 'es-ES', nativeName: 'Español',    englishName: 'Spanish' },
  { code: 'it', bcp47: 'it-IT', nativeName: 'Italiano',   englishName: 'Italian' },
  { code: 'nl', bcp47: 'nl-NL', nativeName: 'Nederlands', englishName: 'Dutch' },
  { code: 'pl', bcp47: 'pl-PL', nativeName: 'Polski',     englishName: 'Polish' },
  { code: 'pt', bcp47: 'pt-PT', nativeName: 'Português',  englishName: 'Portuguese' },
] as const;

export const SUPPORTED_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export const isSupportedLocale = (code?: string | null): boolean =>
  !!code && SUPPORTED_CODES.includes(code);

export const bcp47Of = (code: string): string =>
  SUPPORTED_LANGUAGES.find((l) => l.code === code)?.bcp47 ?? 'de-DE';
